export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173'),
	() => import('./nodes/174'),
	() => import('./nodes/175'),
	() => import('./nodes/176'),
	() => import('./nodes/177'),
	() => import('./nodes/178'),
	() => import('./nodes/179'),
	() => import('./nodes/180'),
	() => import('./nodes/181'),
	() => import('./nodes/182'),
	() => import('./nodes/183'),
	() => import('./nodes/184'),
	() => import('./nodes/185'),
	() => import('./nodes/186'),
	() => import('./nodes/187'),
	() => import('./nodes/188'),
	() => import('./nodes/189'),
	() => import('./nodes/190'),
	() => import('./nodes/191'),
	() => import('./nodes/192'),
	() => import('./nodes/193'),
	() => import('./nodes/194'),
	() => import('./nodes/195'),
	() => import('./nodes/196'),
	() => import('./nodes/197'),
	() => import('./nodes/198'),
	() => import('./nodes/199'),
	() => import('./nodes/200'),
	() => import('./nodes/201'),
	() => import('./nodes/202'),
	() => import('./nodes/203'),
	() => import('./nodes/204'),
	() => import('./nodes/205'),
	() => import('./nodes/206'),
	() => import('./nodes/207')
];

export const server_loads = [2,32,36];

export const dictionary = {
		"/(app)/(anonymous)": [~38,[2,3]],
		"/(app)/(connected)/(app)/admin": [49,[2,5,6,7]],
		"/(app)/(connected)/(app)/admin/business/[hash]": [50,[2,5,6,7,8]],
		"/(app)/(connected)/(app)/admin/business/[hash]/billing-settings": [51,[2,5,6,7,8]],
		"/(app)/(connected)/(app)/admin/business/[hash]/features": [52,[2,5,6,7,8]],
		"/(app)/(connected)/(app)/admin/jws-tester": [53,[2,5,6,7]],
		"/(app)/(connected)/(app)/dashboard": [54,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/billing/upgrade": [55,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/calendar": [56,[2,5,6,9]],
		"/(app)/(connected)/(app)/dashboard/calendar/booking/new": [58,[2,5,6,9,10]],
		"/(app)/(connected)/(app)/dashboard/calendar/booking/[id]/[[tab]]": [57,[2,5,6,9,10]],
		"/(app)/(connected)/(app)/dashboard/calendar/date/[date]": [59,[2,5,6,9]],
		"/(app)/(connected)/(app)/dashboard/calendar/date/[date]/transactions": [60,[2,5,6,9]],
		"/(app)/(connected)/(app)/dashboard/customers": [61,[2,5,6,11]],
		"/(app)/(connected)/(app)/dashboard/customers/[id]": [62,[2,5,6,11]],
		"/(app)/(connected)/(app)/dashboard/loyalty": [63,[2,5,6,12]],
		"/(app)/(connected)/(app)/dashboard/loyalty/giftcards": [64,[2,5,6,12,13]],
		"/(app)/(connected)/(app)/dashboard/loyalty/giftcards/[id]": [65,[2,5,6,12,13]],
		"/(app)/(connected)/(app)/dashboard/loyalty/packages": [66,[2,5,6,12,14]],
		"/(app)/(connected)/(app)/dashboard/loyalty/packages/[id]": [67,[2,5,6,12,14]],
		"/(app)/(connected)/(app)/dashboard/loyalty/subscriptions": [68,[2,5,6,12]],
		"/(app)/(connected)/(app)/dashboard/payment": [69,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/payment/transactions/[[tab]]": [70,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/reviews": [71,[2,5,6,15]],
		"/(app)/(connected)/(app)/dashboard/reviews/[id]": [72,[2,5,6,15]],
		"/(app)/(connected)/(app)/dashboard/stats": [73,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/support": [74,[2,5,6]],
		"/debug/(dev)": [144,[28,29]],
		"/debug/(dev)/colors": [145,[28,29]],
		"/debug/(dev)/emptyPage": [146,[28,29]],
		"/debug/(prod)/error": [156,[28]],
		"/debug/(dev)/pushState": [147,[28,29]],
		"/debug/(dev)/revolut": [148,[28,29]],
		"/debug/(dev)/richTextArea": [149,[28,29]],
		"/debug/(dev)/showcase": [150,[28,29]],
		"/debug/(dev)/showcase/[name]": [151,[28,29]],
		"/debug/(dev)/stancer": [152,[28,29]],
		"/debug/(dev)/test/byebye": [153,[28,29]],
		"/debug/(dev)/test/page/new": [155,[28,29]],
		"/debug/(dev)/test/page/[id]": [154,[28,29]],
		"/emails/transactional": [157,[30]],
		"/(app)/(connected)/(app)/google/callback": [75,[2,5,6]],
		"/(app)/(anonymous)/google/opt-out": [44,[2,3]],
		"/(app)/logout": [141,[2]],
		"/(app)/(connected)/onboarding": [129,[2,5,25]],
		"/(app)/(connected)/onboarding/(start)/inventory": [130,[2,5,25,26]],
		"/(app)/(connected)/onboarding/(start)/offers": [131,[2,5,25,26]],
		"/(app)/(connected)/onboarding/(start)/offers/collections/[id]": [133,[2,5,25,26]],
		"/(app)/(connected)/onboarding/(start)/offers/event/[id]": [134,[2,5,25,26]],
		"/(app)/(connected)/onboarding/(start)/offers/type": [135,[2,5,25,26]],
		"/(app)/(connected)/onboarding/(start)/offers/[id]": [132,[2,5,25,26]],
		"/(app)/(connected)/onboarding/(start)/opening-hours": [136,[2,5,25,26]],
		"/(app)/(connected)/onboarding/(start)/profile": [137,[2,5,25,26]],
		"/(app)/(connected)/onboarding/(start)/public": [138,[2,5,25,26]],
		"/(app)/(connected)/onboarding/terms": [139,[2,5,25]],
		"/(app)/(connected)/onboarding/widget": [140,[2,5,25]],
		"/(app)/(anonymous)/(t-c)/privacy": [41,[2,3,4]],
		"/(app)/qr-code/[token]/[date]": [142,[2,27]],
		"/(app)/(anonymous)/recover-password/[token]": [45,[2,3]],
		"/(app)/(anonymous)/redirect/collect-payment": [46,[2,3]],
		"/(app)/(anonymous)/registration": [47,[2,3]],
		"/(app)/(anonymous)/registration/step-1": [~48,[2,3]],
		"/(app)/(anonymous)/(landing)/reservation-en-ligne-entrepeneur-tpe-artisan": [~39,[2,3]],
		"/(app)/reservation-list/[token]/[date]": [143,[2]],
		"/(app)/(anonymous)/(landing)/resevation-en-ligne-entrepeneur-tpe-artisan": [~40,[2,3]],
		"/(app)/(connected)/(app)/settings/(simple)": [78,[2,5,6,16]],
		"/(app)/(connected)/(app)/settings/(legacy)/activity": [76,[2,5,6]],
		"/(app)/(connected)/(app)/settings/(legacy)/activity/[id]": [77,[2,5,6]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/billing": [79,[2,5,6,16,17,18]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/billing/invoices": [80,[2,5,6,16,17,18]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/billing/invoices/[id]": [81,[2,5,6,16,17,18]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/billing/payment-method": [82,[2,5,6,16,17,18]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/communications": [83,[2,5,6,16,17,19]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/communications/emails": [84,[2,5,6,16,17,19]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/communications/sms": [85,[2,5,6,16,17,19]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/custom-fields": [86,[2,5,6,16,17]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/custom-fields/[id]": [87,[2,5,6,16]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/events": [88,[2,5,6,16,17,20]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/events/logs": [90,[2,5,6,16,17,20]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/events/reconfirm": [91,[2,5,6,16,17,20]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/events/reminder": [92,[2,5,6,16,17,20]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/events/review": [93,[2,5,6,16,17,20]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/events/[id]": [89,[2,5,6,16,17,20]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/giftcards": [94,[2,5,6,16]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/giftcards/[id]": [95,[2,5,6,16]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/google-calendar": [96,[2,5,6,16]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/google-reserve": [97,[2,5,6,16]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/inventory": [98,[2,5,6,16,17]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/media-library": [99,[2,5,6,16,17]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/notifications": [100,[2,5,6,16,17]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/offers": [101,[2,5,6,16,17]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/offers/collections/[id]": [103,[2,5,6,16,17]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/offers/event/[id]": [104,[2,5,6,16]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/offers/planning/[[guestPriceId]]": [105,[2,5,6,16,17]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/offers/type": [106,[2,5,6,16]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/offers/[id]": [102,[2,5,6,16,17]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/opening-hours": [107,[2,5,6,16,17]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/packages": [108,[2,5,6,16,21]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/packages/[id]": [109,[2,5,6,16,21]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/payment-upgrade": [111,[2,5,6,16,17]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/payment": [110,[2,5,6,16]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/products": [112,[2,5,6,16,22]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/products/[id]": [113,[2,5,6,16,22]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/profile": [114,[2,5,6,16,17]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/promo-codes": [115,[2,5,6,16,23]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/promo-codes/bulk": [117,[2,5,6,16,23]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/promo-codes/[id]": [116,[2,5,6,16,23]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/reconfirmation": [118,[2,5,6,16]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/referral": [119,[2,5,6,16,17]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/split-payment": [120,[2,5,6,16]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/widget": [121,[2,5,6,16,17,24]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/widget/bookings": [122,[2,5,6,16,17,24]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/widget/contact": [123,[2,5,6,16,17,24]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/widget/design": [124,[2,5,6,16,17,24]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/widget/giftcards-packs": [125,[2,5,6,16,17,24]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/widget/install": [126,[2,5,6,16,17,24]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/widget/member-area": [127,[2,5,6,16,17,24]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/widget/options": [128,[2,5,6,16,17,24]],
		"/(app)/(anonymous)/(t-c)/terms-widget": [43,[2,3,4]],
		"/(app)/(anonymous)/(t-c)/terms": [42,[2,3,4]],
		"/widget": [~158,[31]],
		"/widget/[hash]": [159,[31,32]],
		"/widget/[hash]/auth/jws": [160,[31,32]],
		"/widget/[hash]/auth/login": [161,[31,32]],
		"/widget/[hash]/auth/okta": [162,[31,32]],
		"/widget/[hash]/booking/[id]/split": [177,[31,32]],
		"/widget/[hash]/booking/[id]/split/payment-confirm": [178,[31,32]],
		"/widget/[hash]/booking/[id]/split/thank-you": [179,[31,32]],
		"/widget/[hash]/book": [163,[31,32,33]],
		"/widget/[hash]/book/activity": [167,[31,32,33]],
		"/widget/[hash]/book/customer": [168,[31,32,33]],
		"/widget/[hash]/book/error": [169,[31,32,33]],
		"/widget/[hash]/book/events": [170,[31,32,33]],
		"/widget/[hash]/book/hub": [171,[31,32,33]],
		"/widget/[hash]/book/offer": [172,[31,32,33]],
		"/widget/[hash]/book/pax": [173,[31,32,33]],
		"/widget/[hash]/book/payment": [174,[31,32,33]],
		"/widget/[hash]/book/price": [175,[31,32,33]],
		"/widget/[hash]/book/product": [176,[31,32,33]],
		"/widget/[hash]/book/[bookingId]/payment-confirm": [164,[31,32,33]],
		"/widget/[hash]/book/[bookingId]/payment-retry": [165,[31,32,33]],
		"/widget/[hash]/book/[bookingId]/thank-you": [166,[31,32,33]],
		"/widget/[hash]/giftcards": [180,[31,32,34]],
		"/widget/[hash]/giftcards/check": [181,[31,32,34]],
		"/widget/[hash]/giftcards/g/[giftcardId]": [~182,[31,32,34]],
		"/widget/[hash]/giftcards/pay-confirm/[id]": [184,[31,32,34]],
		"/widget/[hash]/giftcards/pay": [183,[31,32,34]],
		"/widget/[hash]/giftcards/recipients": [185,[31,32,34]],
		"/widget/[hash]/giftcards/select": [186,[31,32,34]],
		"/widget/[hash]/giftcards/send-date": [187,[31,32,34]],
		"/widget/[hash]/giftcards/sender": [188,[31,32,34]],
		"/widget/[hash]/google-reserve": [189,[31,32]],
		"/widget/[hash]/inactive": [190,[31,32]],
		"/widget/[hash]/member": [191,[31,32,35]],
		"/widget/[hash]/member/bookings": [192,[31,32,35]],
		"/widget/[hash]/member/payment": [193,[31,32,35]],
		"/widget/[hash]/member/profile": [194,[31,32,35]],
		"/widget/[hash]/my-booking/[bookingId]": [195,[31,32,36]],
		"/widget/[hash]/my-booking/[bookingId]/cancel": [~196,[31,32,36]],
		"/widget/[hash]/my-booking/[bookingId]/guarantee": [197,[31,32,36]],
		"/widget/[hash]/my-booking/[bookingId]/pay/[paymentId]": [198,[31,32,36]],
		"/widget/[hash]/my-booking/[bookingId]/reconfirm": [199,[31,32,36]],
		"/widget/[hash]/my-booking/[bookingId]/survey": [200,[31,32,36]],
		"/widget/[hash]/packages": [201,[31,32,37]],
		"/widget/[hash]/packages/pay-confirm/[id]": [204,[31,32,37]],
		"/widget/[hash]/packages/pay": [203,[31,32,37]],
		"/widget/[hash]/packages/p/[id]": [~202,[31,32,37]],
		"/widget/[hash]/packages/select": [205,[31,32,37]],
		"/widget/[hash]/terms": [206,[31,32]],
		"/widget/[hash]/welcome": [207,[31,32]]
	};

export const hooks = {
	handleError: (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);